import React from 'react'
import { Descriptions } from 'antd'
import { add, toDate } from 'date-fns'
import { IPeriodCache } from '../../lib/interfaces'
import './style.less'
import { convertDateToLocalTime, formatText } from '../../lib/dateFunctions'

function formatterFactory(size) {
    return function statFormatter(value) {
        try {
            formatText(toDate(new Date(value)), 'dd-MM-yyyy')
        } catch (ex) {
            return <p> </p>
        }
        return value ? (
            <p style={{ fontSize: size }}>{formatText(toDate(new Date(value)), 'dd-MM-yyyy')}</p>
        ) : (
            <p style={{ fontSize: size }}>{'ukendt'}</p>
        )
    }
}

export default function ReportMeta({
    llPeriod,
}: {
    llPeriod: IPeriodCache
}) {

    return (
        <div className="site-layout-reporting">
            <Descriptions title="Report Info" bordered size="small" column={1}>
                <Descriptions.Item label="Startdato for udlandsophold">
                    {formatterFactory(16)(llPeriod?.start ? llPeriod?.start.toString() : null)}
                </Descriptions.Item>
                <Descriptions.Item label="Slutdato for udlandsophold (hvis kendt)">
                    {formatterFactory(16)(llPeriod?.end ? llPeriod?.end.toString() : null)}
                </Descriptions.Item>
                <Descriptions.Item label="Dato for 6 måneder fra beregningsdato">
                    {formatterFactory(16)(
                        add(add(toDate(convertDateToLocalTime(new Date(llPeriod?.start))), { months: 6 }), {
                            days: -1,
                        }).toString()
                    )}
                </Descriptions.Item>
            </Descriptions>
        </div>
    )
}
